import { WidgetDataSource } from '../../../../../../../models';
import {
  Comparison,
  Widget,
  WidgetGroup,
} from '../../../../../../../providers/bridge-api/dashboard.service';
import { FieldService } from '../../../../../../../providers/storage-api/field.service';
import { WidgetChartOptions } from '../../../../widget-chart/widget-chart.component';
import { AiInsightPayloadParams } from './widget-ai-insights-point-selection.service';
import { WidgetPointSelection } from './widget-point-selection';

export class DonutPointSelection extends WidgetPointSelection {
  override assemblePayloadFromSelection(
    selectedPoints: any[],
    widget: Widget<WidgetChartOptions>,
    dataSource: WidgetDataSource,
    widgetGroup?: WidgetGroup,
    comparison?: Comparison
  ): AiInsightPayloadParams {
    const payload = super.assemblePayloadFromSelection(
      selectedPoints,
      widget,
      dataSource,
      widgetGroup,
      comparison
    );

    const { donutOptions } = widget.payload;

    const getScore = (point) => {
      if (donutOptions.scoring === 'box') {
        return point.y;
      }
      return (point.y / point.series.options.custom.documentCount) * 100;
    };

    const flattenedPoints = selectedPoints.flat();
    for (let i = 0; i < flattenedPoints.length; i++) {
      payload.buckets[i].aggregate_rating_score = getScore(flattenedPoints[i]);
    }

    payload.scene_params.best_rating_value = donutOptions.maxRating;
    payload.scene_params.worst_rating_value = donutOptions.minRating;
    payload.scene_params.metric_calculation = donutOptions.scoring;
    if (donutOptions.scoring === 'box') {
      payload.scene_params.box_options = `Top:${donutOptions.topBoxSize},Neutral,Bottom:${donutOptions.bottomBoxSize}`;
    }
    payload.scene_params.rating_field = FieldService.getFieldLongName(widget.payload.analyticItem);

    return payload;
  }
}
